import AgendaBox from "..";
const routes = [
    { name: "AgendaBoxListPage", path: "/agendabox", component: AgendaBox.AgendaBoxListPage, meta: { title: "Configurazione Agenda Box" } }]
    ;
export default routes;
